import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab";
import TimelineOppositeContent, { timelineOppositeContentClasses } from "@mui/lab/TimelineOppositeContent";
import { Stack, Typography } from "@mui/material";
import { formatUTCDateWithLocalTime, parseMs } from "../../utils";
import { TextWithLinks } from "../checks/checkNotes/TextWithLinks";
import { CustomAvatar } from "../components/custom-avatar";
import { FundingPackageNote } from "./types";

const NotesHistory = ({ notes = [] }: { notes: FundingPackageNote[] }) => {
  const sortedNotes = [...notes].sort(
    (a: FundingPackageNote, b: FundingPackageNote) => parseMs(b.createdAt) - parseMs(a.createdAt)
  );

  return (
    <>
      {sortedNotes?.length > 0 && (
        <Stack direction="column" spacing={2}>
          <Typography variant="subtitle1">History</Typography>
          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.4
              }
            }}
          >
            {sortedNotes?.map((n) => {
              return (
                <TimelineItem key={n.id}>
                  <TimelineOppositeContent color="textSecondary" width={300}>
                    <Stack direction="column">
                      <Typography variant="caption">{n?.createdByUser?.fullName}</Typography>
                      <Typography variant="caption">{formatUTCDateWithLocalTime(n.createdAt)}</Typography>
                    </Stack>
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot variant="outlined">
                      <CustomAvatar
                        alt={n.createdByUser?.fullName}
                        name={n.createdByUser?.fullName}
                        sx={{ width: 22, height: 22, fontSize: 12 }}
                      />
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <TextWithLinks text={n.noteText} />
                  </TimelineContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        </Stack>
      )}
    </>
  );
};

export default NotesHistory;
